
import moment from 'moment';

export const formatDate = (date: number | string | null): string => {
    if (date == null) {
        return "unknown"
    }

    return moment(typeof date === 'string' ? date : Number(date)).format('MMMM Do Y')
}

export const formatDateForBirth = (epoch: number): string=> {
    return moment(Number(epoch)).format('MM-DD-YYYY')
}

export const formatDateTime = (epoch: number): string => {
    return moment(Number(epoch)).format('ddd, MMMM Do - hh:mm a')
}

export const formatDateTimeToDay = (epoch: number): string => {
    return moment(Number(epoch)).format('MMMM Do')
}
